// api_adapters/finacraft_api.js
import axios from "axios";
import { incrementLoader, decrementLoader } from "../loader/loaderStore";

const finacraft_api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://localhost:8000", // fallback for dev
  withCredentials: true, // Needed if backend sets cookies
  headers: {
    "Content-Type": "application/json",
  },
});

// Function to dynamically set Authorization header
export const setAccessToken = (token) => {
  if (token) {
    finacraft_api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    delete finacraft_api.defaults.headers.common["Authorization"];
  }
};

// Request interceptor: show fullscreen loader for every API call
finacraft_api.interceptors.request.use((config) => {
  incrementLoader();
  return config;
});

// Response interceptor: hide loader on success + 401 retry logic
finacraft_api.interceptors.response.use(
  (response) => {
    decrementLoader();
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    // If 401 and we haven't retried yet
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      const refreshToken = localStorage.getItem("refresh_token");
      if (!refreshToken) {
        decrementLoader();
        return Promise.reject(error);
      }

      try {
        const res = await axios.post(
          `${process.env.REACT_APP_API_URL || "http://localhost:8000"}/auth/token/refresh/`,
          { refresh: refreshToken },
          { withCredentials: true }
        );

        const newAccessToken = res.data.access;
        localStorage.setItem("access_token", newAccessToken);
        setAccessToken(newAccessToken);

        // Decrement for the original failed request; retry will increment on its own
        decrementLoader();

        // Retry original request with new token
        originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;
        return finacraft_api(originalRequest);
      } catch (err) {
        localStorage.removeItem("access_token");
        localStorage.removeItem("refresh_token");
        decrementLoader();
        return Promise.reject(err);
      }
    }

    decrementLoader();
    return Promise.reject(error);
  }
);

export default finacraft_api;
